import { render, staticRenderFns } from "./personInfo.vue?vue&type=template&id=c8bfd72e&scoped=true"
import script from "./personInfo.vue?vue&type=script&lang=js"
export * from "./personInfo.vue?vue&type=script&lang=js"
import style0 from "./personInfo.vue?vue&type=style&index=0&id=c8bfd72e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bfd72e",
  null
  
)

export default component.exports